"use client";

import type { OmniboxDemo } from "@mw/shared/payload-types";

import { useTranslations } from "next-intl";
import { createContext, useContext } from "react";

export interface ITranslationContext {
  t: ReturnType<typeof useTranslations<"ClientKeys.SpeechToText">>;
}

export function useSTTTranslations(
  props: OmniboxDemo["sttTranslations"] = {},
): ReturnType<typeof useTranslations<"ClientKeys.SpeechToText">> {
  const t = useTranslations("ClientKeys.SpeechToText");
  // @ts-expect-error - proxy not going through perfectly. Since this is going to be refactored anyway it should be fine.
  return (...args: Parameters<typeof t>) => {
    switch (args[0]) {
      case "widget.cta.desktop":
        return props.ctaDesktop || t(...args);
      case "widget.cta.mobile":
        return props.ctaMobile || t(...args);
      case "widget.help_text_v1_5":
        return props.helpText || t(...args);
      default:
        return t(...args);
    }
  };
}

export const TranslationContext = createContext<ITranslationContext>({
  // @ts-expect-error
  t: () => "",
});

export function useSTTTranslationCtx() {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error("useSTTTranslations must be used within a TranslationProvider");
  }
  return context.t;
}
